import React, {Component} from 'react'
import ClientSideCacheController from '../ClientSideCacheController'
import Cannonicalize from '../Cannonicalize'
import {PieChart, Pie, Cell} from 'recharts'
import ZipInput from '../ZipInput'
import ToolTip from '../ToolTip'

const uvIndexFillColor = function(i){
  if(!i)
    return 'transparent'
  let uv = parseInt(i,10)

  if(uv <= 2)
    return '#2F9418'
  if(uv <= 5)
    return '#F6E232'
  if(uv <= 7)
    return '#F65A1F'
  if(uv <= 10)
    return '#D70A1E'
  return '#6C4EC8'
}

const airQualityFillColor = function(i){
  if(!i)
    return 'transparent'
  if(i === 'Low')
    return '#24E229'
  if(i === 'Moderate')
    return '#FFFD38'
  if(i === 'Unhealthy for Sensitive Groups')
    return '#FD7E24'
  if(i === 'Unhealthy')
    return '#FC0D1C'
  if(i === 'Very Unhealthy')
    return '#97084C'
  if(i === 'Hazardous')
    return '#7C0425'
  return 'transparent'
}

const circumference = 160;
class BaronWeatherSummary extends Component {
  constructor(props) {
    super(props)
    this.affiliate = props.affiliate;
    this.state = {}
    this.state.percent = 0
  }

  componentWillMount() {
    try {
      let data = Cannonicalize.metar(this.props.FRN_rawResponses[0].data)

        data.percent = 0
        data.percent = Math.round(data.temperature.value * 100 / 115)
      this.setState(data)
    } catch (e) {
      console.log('Weather Summary got bad metar data from FRN_ in Weather Summary', e)
    }

    try {
      let data = Cannonicalize.moon(this.props.FRN_rawResponses[1].data)
      this.setState({moon : data})
    } catch (e) {
      console.log('Weather Summary got bad moon data from FRN_ in Weather Summary', e)
    }
    if (typeof window !== 'object')
      return

    ClientSideCacheController.setAffiliate(this.props.affiliate)
    ClientSideCacheController.get('metar').then((data) => {
      data.percent = 0
      data.percent = Math.round(data.temperature.value * 100 / 115)
      this.setState(data)
      // console.log('metar', data)
    })
    ClientSideCacheController.get('moon').then((data) => {
      this.setState({moon : data})
      // console.log('moon', data)
    })

  }


  rgb() {
    var red = Math.round(this.state.percent * 2.55);
    var green = 0;
    var blue = Math.round((100 - this.state.percent) * 2.55);
    return `rgb(${red},${green},${blue})`
  }

  airQualityEndAngle(){
    if(!this.state.airQuality)
      return 0
    if(this.state.airQuality === 'Low')
      return 30
    if(this.state.airQuality === 'Moderate')
      return 60
    if(this.state.airQuality === 'Unhealthy for Sensitive Groups')
      return 90
    if(this.state.airQuality === 'Unhealthy')
      return 120
    if(this.state.airQuality === 'Very Unhealthy')
      return 150
    if(this.state.airQuality === 'Hazardous')
      return 180
    return 0
  }

  render() {
    return (<div className=" row">
      <div className="col-xs-12 hidden-sm hidden-xs">
        <div className="gnm-baron-weather-summary row">
          <div className="col-xs-12 visible-md-block visible-lg-block ">
              <div>
                <span className='zip-picker'>{this.state.updated} in </span>
                <ZipInput>
                  <a className="dark zip-picker">{this.state.city}, {this.state.stateAbbrev}<span className="fa fa-map-marker"></span></a>
                </ZipInput>
              </div>
              <div className="icon-container">
                <svg viewBox="0 0 100 50" fill="transparent">
                  <path d="M 50,50 m -49,0 a 49,49 0 1 1 98,0" stroke="#edebeb" strokeWidth="1" fillOpacity="0"></path>
                  <path d="M 50,50 m -49,0 a 49,49 0 1 1 98,0" stroke={this.rgb()} strokeWidth="2" fillOpacity="0" strokeDasharray={circumference} strokeDashoffset={circumference * (1 - this.state.percent / 100)}></path>
                </svg>
                <span className="icon-box">
                  <img height="auto" width="auto" src={this.state.conditionIcon} />
                </span>
                <span className="temperature" style={{
                    color: this.rgb()
                  }}>{this.state.temperature ? this.state.temperature.value : ''}</span>
                <div >{this.state.weather_code ? this.state.weather_code.text : ''}</div>
              </div>
              <div >
                <div className="packed">
                  <span >Feels Like</span>
                  <div className='h4'>{this.state.feels_like}<sup>&deg;</sup></div>
                </div>
                <div className="packed">
                  <span>Humidity</span>
                  <div className='h4'>{this.state.relative_humidity ? this.state.relative_humidity.value : ''}<span>%</span></div>
                </div>
                <div className="packed">
                  <span>Dew Point</span>
                  <div className='h4'>{this.state.temperature ? this.state.temperature.dew_point : ''}<sup>&deg;</sup>
                  </div>
                </div>
                <div className="packed">
                  <span>Visibility</span>
                  <div className='h4'>{this.state.visibility ? this.state.visibility.value : ''}<span>mi</span></div>
                </div>

                {/*}<div className="pie-chart-container air-quality" >
                  <div className='text-center'>Air Quality
                    <ToolTip iconClassName='fa fa-info-circle' title="Air Quality Legend" width={300} height={240}>
                      <ul>
                        <li><span style={{color: airQualityFillColor('Low')}}>&#9632;</span>Air quality is considered satisfactory, and air pollution poses little or no risk.</li>
                        <li><span style={{color: airQualityFillColor('Moderate')}}>&#9632;</span>Air quality is acceptable; for some pollutants there may be a moderate heath concern for sensitive people.</li>
                        <li><span style={{color: airQualityFillColor('Unhealthy for Sensitive Groups')}}>&#9632;</span>General public is not likely to be affected, but people with lung disease, older adults and children may. </li>
                        <li><span style={{color: airQualityFillColor('Unhealthy')}}>&#9632;</span>Everyone may begin to experience some adverse health effects.</li>
                        <li><span style={{color: airQualityFillColor('Very Unhealthy')}}>&#9632;</span>This would trigger a heath alert signifying that everyone may experience more serious health effects.</li>
                        <li><span style={{color: airQualityFillColor('Hazardous')}}>&#9632;</span>This would trigger health warnings of emergency conditions. The entire population would be affected.</li>
                      </ul>
                    </ToolTip>
                  </div>
                  <div className='pie-chart'>
                    <PieChart width={100} height={100} style={{transform: 'rotateY(180deg)'}}>
                      <Pie data={[
                        {dummy: 'none', value:this.airQualityEndAngle()},
                        {dummy: 'none', value: 180 - this.airQualityEndAngle()}
                      ]} dataKey="value" nameKey="dummy"
                         outerRadius={50} innerRadius={35} endAngle={180} >
                         <Cell fill={airQualityFillColor(this.state.airQuality)} />
                         <Cell fill='#cccccc' />
                      </Pie>
                    </PieChart>
                    <span style={{position:'absolute',top:'36px',left:'23px',width:'68px'}}>{this.state.airQuality}</span>
                  </div>
                </div> */}
                <div className="pie-chart-container moon">
                  <span>Moon Phase</span>
                  <div>
                    {this.state.moon ? <Moon phase={this.state.moon.phase}></Moon> : null}
                  </div>
                  <div className='moon-phase-label'>{this.state.moon ? this.state.moon.phase : ''} Moon</div>
                </div>
                {/*
                <div className=" pie-chart-container uv-index" >
                  <div className='text-center'>UV Index
                    <ToolTip iconClassName='fa fa-info-circle' title="UV Index Legend" width={300} height={240}>
                      <ul>
                        <li><span style={{color: uvIndexFillColor(1)}}>&#9632;</span>0-2 Wear sunglasses on bright days: use sunscreen when snow is on the ground, as it reflects UV radiation.</li>
                        <li><span style={{color:  uvIndexFillColor(3)}}>&#9632;</span>3-5 Wear sunglasses, use SPF 30+ sunscreen, cover the body with clothing and a hat, seek shade midday.</li>
                        <li><span style={{color:  uvIndexFillColor(6)}}>&#9632;</span>6-7 In addition to the above, reduce time in the sun from between 11am and 4pm.</li>
                        <li><span style={{color: uvIndexFillColor(8)}}>&#9632;</span>8-10 Take all precautions listed above and try and avoid going out into the sun between 11:00am and 4pm.</li>
                        <li><span style={{color:  uvIndexFillColor(11)}}>&#9632;</span>11+ Take all precautions listed above and try and limit your sun exposure as much as possible. </li>
                      </ul>
                    </ToolTip>
                  </div>
                  <div className='pie-chart' >
                    <PieChart width={100} height={100} style={{transform: 'rotateY(180deg)'}}>
                      <Pie data={[
                        {dummy: 'none', value:parseInt(this.state.uvIndex,10)},
                        {dummy: 'none', value: 10 - parseInt(this.state.uvIndex,10)}
                      ]} dataKey="value" nameKey="dummy"
                         outerRadius={50} innerRadius={35} endAngle={180}>
                         <Cell fill={uvIndexFillColor(this.state.uvIndex)} />
                         <Cell fill='#cccccc' />
                      </Pie>
                    </PieChart>
                    <span style={{position:'absolute',top:'36px',left:'43px'}}>{this.state.uvIndex}</span>
                  </div>
                </div>
                */}

              </div>
              <div className="">
                <div className="packed">
                  <span>Wind Speed</span>
                  <div className='h4'>{this.state.wind ? this.state.wind.speed : ''}<span> mph</span></div>
                </div>
                <div className="packed">
                  <span>Wind Direction</span>
                  <div className='h4'>{this.state.wind ? this.state.wind.dir : ''}</div>
                </div>
                <div className="packed">
                  <span>Pressure</span>
                  <div className='h4'>{this.state.pressure ? this.state.pressure.value : ''}<span>in</span></div>
                </div>
                <div className="packed">
                  <span>Sky Coverage</span>
                  <div className='h4'>{this.state.cloud_cover ? this.state.cloud_cover.value : ''}<span>%</span></div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div className="col-xs-12 visible-xs-block visible-sm-block ">
        <div className="gnm-weather-summary-small row no-gutter ">
          <div className="col-xs-12">
            <div>
              <span>{this.state.updated}&nbsp;in&nbsp;</span>
              <ZipInput>
                <a href="#">{this.state.city}, {this.state.stateAbbrev}<span className="fa fa-map-marker"></span>
                </a>
              </ZipInput>
            </div>
          </div>
          <div className='col-xs-12'>
            <div className='row'>
              <div className="col-xs-6">
                <img src='asdf'/>
                <h2>{this.state.temperature ? this.state.temperature.value : ''}<sup>&deg;</sup>
                </h2>
                <p>{this.state.weather_code ? this.state.weather_code.text : ''}</p>
              </div>
              <div className="col-xs-6">
                <img className='img-responsive travis' src={this.props.meteorologistImage} ></img>
              </div>
            </div>
          </div>
          <div className='col-xs-12'>
            <div className='row'>
              <div className="col-xs-6 button-radar">
                <a href={
                    this.affiliate == 'kotv'
                      ? '/warn-interactive-live-radar'
                      : '/nextgen-live-radar'
                  } className="radar">{
                    this.affiliate == 'kotv'
                      ? 'WARN Radar'
                      : 'NextGen Radar'
                  }</a>
              </div>
              <div className="col-xs-6 button-radar">
                <a href="/national-radar" className="radar">National Radar</a>
              </div>
            </div>
          </div>
          <div className="col-xs-12">
            <ul className='summary-list'>
              <li>
                <span>Feels Like</span>
                <h4>&nbsp;{this.state.feels_like}<sup>&deg;</sup>
                </h4>
              </li>
              <li>
                <span>Dew Point</span>
                <h4>&nbsp;{this.state.temperature ? this.state.temperature.dew_point : ''}<sup>&deg;</sup>
                </h4>
              </li>
              <li>
                <span>Humidity</span>
                <h4>&nbsp;{this.state.relative_humidity ? this.state.relative_humidity.value : ''}%</h4>
              </li>
              <li>
                <span>Pressure</span>
                <h4>&nbsp;{this.state.pressure ? this.state.pressure.value : ''}&nbsp;in</h4>
              </li>
              <li>
                <span>Wind Speed</span>
                <h4>&nbsp;{this.state.wind ? this.state.wind.speed : ''}&nbsp;mph
                </h4>
              </li>
              <li>
                <span>Wind Direction</span>
                <h4>&nbsp;{this.state.wind ? this.state.wind.dir : ''}
                </h4>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>)
  }
}

const Moon = (props) => {
  let show = true;
  let invert = false;
  let rx,transform;
  let ellipseStroke = 'none'
  switch (props.phase) {
    case 'New':
      rx = '0.72';
      transform = 'rotate(0) scale(1)'
      break;
    case 'Waxing Crescent':
      rx = '0.6';
      transform = 'rotate(170) scale(1)'
      break;
    case 'First Quarter':
      rx = '0';
      transform = 'rotate(160) scale(1)'
      break;
    case 'Waxing Gibbous':
      rx = '0.3';
      transform = 'rotate(-10) scale(1)';
      invert = true;
      break;
    case 'Full':
      rx = '0.72';
      transform = 'rotate(0) scale(1)';
      invert = true;
      ellipseStroke = 'black'
      break;
    case 'Waning Gibbous':
      rx = '0.3';
      transform = 'rotate(-160) scale(1)';
      invert = true;
    break;
    case 'Last Quarter':
      rx = '0';
      transform = 'rotate(20) scale(1)'
      break;
    case 'Waning Crescent':
      rx = '0.6';
      transform = 'rotate(10) scale(1)'
      break;
    default:
      rx ='0'
      transform=''
      show = false;
  }

  return (
            <svg strokeWidth="0.015" x="0" y="0" width="70" height="70" viewBox="-1 -1 2 2" style={{display: show ? 'inline': 'none', position:'relative',top:'4px',marginRight:'3px'}}>
              <g transform={transform}>
                <circle fill={invert ? 'black' : "white"} stroke="black" cx="0" cy="0" r="0.72"></circle>
                <circle fill={invert ? 'black': "white"} stroke="none" cx="0" cy="0" r="0.72"></circle>
                <path fill={invert ? 'white': "black"} stroke={invert ? 'white' : 'black'} d="M 0,-0.72 A 0.72,0.72 0 1,1 0, 0.72 Z"></path>
                <ellipse fill={invert ? 'white': "black"} stroke={ellipseStroke} cx="0" cy="0" rx={rx} ry="0.72"></ellipse>
              </g>
            </svg>
        )
}



export default BaronWeatherSummary;



// WEBPACK FOOTER //
// ./app/components/custom/ssr/BaronWeatherSummary/index.js